import { render, staticRenderFns } from "./UnregisterPage.vue?vue&type=template&id=1297426e"
import script from "./UnregisterPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnregisterPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports